import {
  AddPaymentRequestsToPaymentDocument,
  PaymentsPageDocument,
} from 'generated/resources/graphql'
import moment from 'moment'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

export const useAddPaymentRequestsMutation = () => {
  const today = moment().format('YYYY-MM-DD')
  const weekStart = moment().startOf('week').format('YYYY-MM-DD')
  const weekEnd = moment().endOf('week').format('YYYY-MM-DD')
  const { company } = useCurrentSession()
  const [addPaymentRequestsBankingPayment, { loading }] = useMutation(
    AddPaymentRequestsToPaymentDocument,
    {
      extractorFn: (data) => data.bankingMutations.addPaymentRequestsBankingPayment,
      refetchQueries: [
        {
          query: PaymentsPageDocument,
          variables: {
            companyId: company.id,
            featureNames: ['dev_finance_swan_reactivation'],
            todayDate: today,
            weekRange: { from: weekStart, to: weekEnd },
          },
        },
      ],
      awaitRefetchQueries: true,
    }
  )

  const submitAddPaymentRequests = async ({
    onSuccess,
    paymentRequestIds,
    paymentId,
  }: {
    onSuccess: () => void
    paymentRequestIds: number[]
    paymentId: number
  }) => {
    const result = await addPaymentRequestsBankingPayment({
      variables: {
        paymentId: paymentId,
        paymentRequestIds: paymentRequestIds,
      },
    })
    const handled = handleResult(result, () => {})
    if (handled.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('banking.bulk_payment.new_bulk_payment_modal.added_payment_requests'),
      })
      onSuccess()
    } else {
      app.setFlash({
        type: 'wrong',
        message: i18n.t('errors.generic_error'),
      })
    }
    return handled
  }

  return {
    submitAddPaymentRequests,
    loading,
  }
}
